// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronRightSmallIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ChevronRightSmallIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M8.757 5.757 13 10l-4.243 4.243-1.06-1.061L10.879 10 7.697 6.818z" />
    </SvgIcon>
  );
});

/**
 * Indicates the ability to navigate to the next step, view overflow items to the right, expand the tree
 * @public
 */
export const ChevronRightSmallIcon = /* @__PURE__ */ Object.assign(
  ChevronRightSmallIconComponent,
  { displayName: 'ChevronRightSmallIcon' },
);
